import { CollegeGoal, getAnnualReturnUsingRiskScore } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const COLLEGE: BaseGoalConfig<CollegeGoal> = {
    iconName: 'GoalCollege',
    color: colorsByGoalType['COLLEGE'].primary,
    defaultName: 'Education',
    getDescription: () =>
        'Education is priceless, but tuition has a price tag.',
    group: 'INVEST',
    blogLink: null,
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
